import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

interface ImageProps extends ComponentProps<'img'> {}

function Image({ className, src, ...rest }: ImageProps) {
  return (
    <img
      className={twMerge(
        'absolute inset-0 size-full select-none object-cover',
        className,
      )}
      src={src}
      alt=""
      loading="lazy"
      {...rest}
    />
  )
}

interface ContainerProps extends ComponentProps<'div'> {}

function Container({ className, ...rest }: ContainerProps) {
  return (
    <div
      className={twMerge(
        'absolute left-1/2 top-1/2 z-10 w-full max-w-7xl -translate-x-1/2 -translate-y-1/2',
        'space-y-4 text-center font-light text-white',
        className,
      )}
      {...rest}
    />
  )
}

interface TitleProps extends ComponentProps<'h2'> {}

function Title({ className, ...rest }: TitleProps) {
  return (
    <h2
      className={twMerge(
        'text-2xl font-light uppercase tracking-[0.425rem] text-white md:text-4xl xl:text-5xl 2xl:text-6xl',
        className,
      )}
      style={{
        textShadow: '3px 3px 6px #000000CC',
      }}
      {...rest}
    />
  )
}

interface DescriptionProps extends ComponentProps<'p'> {}

function Description({ className, ...rest }: DescriptionProps) {
  return (
    <p
      className={twMerge(
        'text-base font-light tracking-widest md:text-2xl',
        className,
      )}
      style={{
        textShadow: '3px 3px 6px #000000',
      }}
      {...rest}
    />
  )
}
interface DescriptionBoldProps extends ComponentProps<'span'> {}

function DescriptionBold({ className, ...rest }: DescriptionBoldProps) {
  return (
    <span
      className={twMerge(
        'text-base font-bold tracking-widest md:text-2xl',
        className,
      )}
      style={{
        textShadow: '3px 3px 6px #000000',
      }}
      {...rest}
    />
  )
}

export { Container, Title, Description, Image, DescriptionBold }
